import React from 'react';

const Emojicon = ({ value, description, ...extra }) => (
  <span role="img" aria-labelledby={description} {...extra}>
    {value}
  </span>
);

export default Emojicon;
